"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Input_1 = require("./Input");

exports.StyledSelect = Input_1.Input.withComponent('select');

exports.Select = function (_a) {
  var required = _a.required,
      placeholder = _a.placeholder,
      children = _a.children,
      options = _a.options,
      optionValue = _a.optionValue,
      optionName = _a.optionName,
      props = __rest(_a, ["required", "placeholder", "children", "options", "optionValue", "optionName"]);

  return react_1.default.createElement(exports.StyledSelect, __assign({}, props), react_1.default.createElement("option", {
    disabled: required,
    value: ""
  }, placeholder), children ? children : options ? options.map(function (option, index) {
    var v = optionValue ? optionValue(option) : option;
    return react_1.default.createElement("option", {
      value: v,
      key: index
    }, optionName ? optionName(option) : option);
  }) : null);
};